import base from "./palette";

export const darkPalette = {
    ...base,
    mode: "dark" as const,
    primary: {
        main: "#39a8e0",
    },
    secondary: {
        main: "#ff4081",
    },
    background: { default: "#0e0e10", paper: "#2e2e2e" },
    text: { primary: "#fafafa", secondary: "#fafafa9c" },
    divider: "#7d7d86ff",
};

export default darkPalette;
